module.exports = __webpack_public_path__ + "static/media/om_hairstyle_loose_front_shadow.30a9adb7.png";